import React, { Component } from 'react'
import Banner from '../../components/tribe/tribe_banner2'
import './css/index.css'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer' 
import certificationimage from '../../assets/image/Learning/certification.jpg'

export default class cerification extends Component {
    render() {
        const image=[
            {image:certificationimage}
        ]
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br className='hide-mobile'/><br className='hide-mobile'/>
                <div className='learning-section'>
                    <Banner bread_crum={['Learning','Certification Programs']} image={image} title="In-house Workshops" subtitle=""/>
                    <br/><br/>
                    <div className='learning-content'>
                        <h2>How we work</h2>
                        <br/><br/>
                        <div className='how'>
                            <p>
                                Lutan Edukasi Certification and Premium Products are complete sets of workshops to equip your people perform more effectively in your organization. The topics Certified Sales Management (CSM), Training Design and Delivery Professiional (TD2P), and Strategy and Performance Execution Excellence (SPEx2) Training System.
                                <br/><br/>
                                <b>Certified Training Design and Delivery Professional (TD2P)</b><br/>
                                Certified TD2P is the most innovative and comprehensive trainer certification program designed to enable your managers develop the advance skills both designing and delivering high impact training. Certification is only provided upon completion of course design and real delivery assignments. Actual training delivery by the participants will be audited by Lutan Edukasi Master Trainer as part of the certification process. A small class size is maintained to ensure plenty of training delivery opportunities for the participants.
                                <br/><br/>
                                Every participants will get :
                                - Participant materials
                                - Handouts
                                - Soft copies of materials and handouts on CD
                                - DVD video recording of delivery practices
                                <br/><br/>
                                <b>Certified Sales Management</b><br/>
                                This program prepares you to become a professional and reliable sales manager, who are ready to face the challenges of sales on this time. This program introduces new knowledge and ways of thinking required by sales managers to face challenges in leading and managing the sales team in this uncertain and difficult era.
                                <br/><br/>
                                Every participant will get:
                                - Participant materials
                                - Handouts
                                - Soft copies of materials and handouts on CD
                                - Lutan Edukasi’s exclusive sales management software
                                <br/><br/>
                                <b>Strategy and Performance Execution Excellence (SPEx2)</b><br/>
                                Our research shows that only 37.5% of organizations execute their strategies well. How is your organization? This workshop will help you to develop your line managers to become strong strategy executioners. Completed with SPEx2 Caliber Survey to measure strategy execution capability in your organization, SPEx2 Performance Dashboard Software, and certification process, this highly interactive workshop will develop strategy execution culture within your organization.
                                <br/><br/>
                                We have identified five competencies that every Line Manager must have to become strategy executors. Our workshops develops your people in these key competencies, and we cover the whole layers in your organization by providing:
                                • SPEx2 for Executives
                                • SPEx2 for Line Managers
                                • SPEx2 for Team Members
                                <br/><br/>
                                These whole range of workshops will help you build strong leadership and execution culture in your organization.
                            </p>
                        </div>
                    </div>
                </div>
                <br/><br/>
                <Footer/>
            </div>
        )
    }
}
